import { useQuery } from "@tanstack/react-query";
import { hubDeliverables } from "@/lib/api";
import { FileText, Film, ClipboardList } from "lucide-react";

const ICON = { roadmap: ClipboardList, audit: FileText, recording: Film };

export default function Deliverables() {
  const { data = [], isLoading } = useQuery({ queryKey: ["hub-deliverables"], queryFn: hubDeliverables });
  return (
    <div data-testid="hub-deliverables">
      <p className="cv-kicker">Deliverables</p>
      <h1 className="cv-display text-3xl mt-4">Roadmaps, audits, recordings.</h1>
      <p className="cv-body text-[#1F1B16]/70 mt-4 max-w-xl">Everything is transition ready and yours to keep.</p>
      {isLoading ? (
        <p className="cv-body text-[#9A938A] mt-8">Loading...</p>
      ) : data.length === 0 ? (
        <p className="cv-body text-sm text-[#9A938A] mt-8">Your deliverables appear here once your engagement begins.</p>
      ) : (
        <div className="mt-8 space-y-3">
          {data.map((d) => {
            const Icon = ICON[d.kind] || FileText;
            return (
              <div key={d.id} data-testid="deliverable-item" className="border border-[rgba(28,27,25,0.14)] rounded-[14px] p-5 flex items-center gap-4">
                <Icon size={20} className="text-[#515E4F] shrink-0" />
                <div className="flex-1">
                  <h3 className="cv-h2 text-sm">{d.title}</h3>
                  <p className="cv-body text-xs text-[#9A938A] mt-1">
                    {d.status === "in_progress" ? "In progress" : "Ready"}{d.date ? ` · ${d.date}` : ""}
                  </p>
                </div>
                {d.url ? (
                  <a href={d.url} target="_blank" rel="noopener noreferrer" className="cv-link">Open</a>
                ) : (
                  <span className="cv-sans uppercase tracking-[0.12em] text-[0.68rem] text-[#9A938A]">Preparing</span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
